import { FormattedMessage } from 'react-intl';
import * as PropTypes from 'prop-types';

import { PageWrapper } from 'modules/layout';

import Form from '../../containers/InfoCategories/UpdateInfoCategoryForm';

const InfoCategoryPage = ({ id }) => (
    <PageWrapper header={<FormattedMessage id="news.update.title" />}>
        <Form id={id} />
    </PageWrapper>
);

InfoCategoryPage.propTypes = {
    id: PropTypes.string.isRequired,
};

export default InfoCategoryPage;
